import IApiClient from "./ApiClient";
import {IndustryResponse} from "models/Industry"
//import { Company } from "models/Company";

export interface IIndustryService {
    search(query: string): Promise<IndustryResponse | undefined>;
  }

export default class IndustryService implements IIndustryService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/industry';
      this.apiClient = apiClient;
    }
  
    async search(query: string): Promise<IndustryResponse|undefined> {
      try {
        const response = await this.apiClient.get<IndustryResponse>(
          `${this.apiBase}/search/?query=${query}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }

    async all(): Promise<IndustryResponse|undefined> {
      try {
        const response = await this.apiClient.get<IndustryResponse>(
          `${this.apiBase}/all/`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }
  }